import ucfirst from '@pkg/utils/strings/ucfirst';

export default function viewModeFromPath(path) {
  const view = path.substring(path.indexOf('=') + 1, path.indexOf('&'));

  return view ? ucfirst(view, true) : 'Not in view mode';
}
